import {FiltersBody} from '@dms/api/core';

import {PRESET_UNBOUNDED_PRICE} from '../../../constants/PRESET_UNBOUNDED_PRICE';
import {UNBOUNDED_PRICE} from '../../../constants/UNBOUNDED_PRICE';
import {FiltersType} from '../types/FiltersType';
import {readCarStatusFilter} from './readCarStatusFilter';

// FiltersBody omits auction carStatus, which sourcing presets also persist.
export const convertFiltersTypeToFiltersBody = (
  filters: FiltersType
): FiltersBody & Pick<FiltersType, 'carStatus'> => ({
  ...filters,
  carStatus: readCarStatusFilter(filters).carStatus,
  priceCZK:
    filters.priceRangeVersion === 2 && filters.priceCZK?.[1] === UNBOUNDED_PRICE
      ? [filters.priceCZK[0], PRESET_UNBOUNDED_PRICE]
      : filters.priceCZK,
  address: filters.address ? filters.address : undefined,
  selectedColors: filters.selectedColors?.map((color) => ({
    key: color.key,
    name: color.label,
    colorCode: color.colorCode ?? '',
  })),
});
